/* eslint no-underscore-dangle: ['error', { allow: [
  _password, _passwordError, _reasonQuestion, _selectedReason,
  _email, _emailFieldName, _emailError
] }] */
import { EventEmitter } from 'events';
import assign from 'object-assign';
import get from 'lodash/get';
import AppDispatcher from '../dispatcher/AppDispatcher';
import Constants from '../constants/Constants';

const { ActionTypes } = Constants;

const CHANGE_EVENT = 'change';

let _password = '';
let _passwordError = '';
let _reasonQuestion = {};
let _selectedReason = '';
let _email = '';
let _emailFieldName = '';
let _emailError;

const DeleteMeStore = assign({}, EventEmitter.prototype, {
  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  /**
  * @param {function} callback
  */
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  /**
  * @param {function} callback
  */
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  /**
  * Set initial data
  */
  setInitialData(data) {
    _password = get(data, 'password', '');
    _passwordError = get(data, 'errors.current_password', []).shift();
    _reasonQuestion = get(data, 'reason_question', {});
    _selectedReason = get(data, 'selected_answer_id', '');
    _email = get(data, 'post_data_email', '');
    _emailFieldName = `answers[${get(_reasonQuestion, '_id', '')}][email]`;
    _emailError = get(data, `errors['${_emailFieldName}']`, []).shift();
  },

  setPassword(value) {
    _password = value;
  },

  getPassword() {
    return _password;
  },

  setPasswordError(value) {
    _passwordError = value;
  },

  getPasswordError() {
    return _passwordError;
  },

  getReasonQuestion() {
    return _reasonQuestion;
  },

  setSelectedReason(value) {
    _selectedReason = value;
  },

  getSelectedReason() {
    return _selectedReason;
  },

  setEmail(value) {
    _email = value;
  },

  getEmail() {
    return _email;
  },

  getEmailFieldName() {
    return _emailFieldName;
  },

  setEmailError(value) {
    _emailError = value;
  },

  getEmailError() {
    return _emailError;
  },
});

DeleteMeStore.dispatchToken = AppDispatcher.register((action) => {
  switch (action.type) {
    case ActionTypes.DELETE_ME_DATA_LOAD_SUCCESS: {
      if (action.data) {
        DeleteMeStore.setInitialData(action.data);
        DeleteMeStore.emitChange();
      }
      break;
    }
    default:
      // do nothing
  }
});

module.exports = DeleteMeStore;
